import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { StakeValidationResult } from 'packages/sports/web/app/src/betslip-base/stake-validation/stake-validation.models';
import { StakeInputMode, StakeInputModeStrategy } from 'packages/sports/web/app/src/numpad/stake-input-mode.strategy';

import { BETSLIP_LINEAR_NUMPAD } from '../../../models';

@Component({
    selector: 'bs-linear-stake-keyboard',
    templateUrl: './linear-stake-keyboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearStakeKeyboardComponent {
    @HostBinding('class') className = 'linear-stake-keyboard';

    readonly keypadId = BETSLIP_LINEAR_NUMPAD;
    readonly StakeInputMode = StakeInputMode;

    error: StakeValidationResult | null = null;

    constructor(public modeStrategy: StakeInputModeStrategy) {}
}
